/** order 공통: 탭, confirm 스토리지 키·정리 함수 등. (confirm 폼용 옵션은 confirm/Body/constants.js) */
export const TAB_BASIC = 'BASIC';
export const TAB_BUDGET = 'BUDGET';
export const TAB_FAVORITE = 'FAVORITE';

/** confirm 페이지 주문 수정(수량/옵션) sessionStorage 키. */
export const ORDER_CONFIRM_OVERRIDES_KEY = 'order-confirm-overrides';

/**
 * confirm 주문 수정 스토리지 제거.
 * 호출 시점: confirm에서 장바구니로 나갈 때(Head 클릭 / Body 선택 없음 리다이렉트), 발주 성공 후 완료 페이지 이동 시.
 */
export function clearOrderConfirmOverrides() {
  sessionStorage.removeItem(ORDER_CONFIRM_OVERRIDES_KEY);
}
